export default "__VITE_ASSET__DXjormIO__"